import { Button } from '@mui/material';
import { Box } from '@mui/system';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import React, { useRef } from 'react'

const FileUploadInput = ({ onFilesSelected }: { onFilesSelected: (files: FileList) => void }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            onFilesSelected(event.target.files);
        }
    }
    return (
        <Box>
            {/* Ukryty input */}
            <input
                type="file"
                multiple
                accept="image/*"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={handleFileChange}
            />

            {/* Stylizowany przycisk MUI */}
            <Button variant="contained" color="primary" onClick={handleButtonClick} startIcon={<UploadFileIcon />}>
                Wybierz zdjęcia
            </Button>
        </Box>
    )
}


export default FileUploadInput